module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Tab is a basic wrapper to manage the content of Nessie Tabs.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Tab label=&quot;Tab title text&quot;&gt;\n    &lt;div&gt;Tab content goes here&lt;/div&gt;\n&lt;/Tab&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Tab/README.md
// module id = 393
// module chunks = 0